import styled from '@emotion/styled';
import { breakpoints } from '~/theme/breakpoints';
export const StyledContent = styled.div(() => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
    [breakpoints.md]: {
        flexDirection: 'row',
        margin: '0 auto',
    },
}));

export const StyledBasketContent = styled.div(({ theme: { sizes, space } }) => ({
    position: 'relative',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    [breakpoints.md]: {
        minWidth: sizes.leftContent,
        flexDirection: 'row',
        padding: `0 0 ${space[3]} 0`,
    },
}));

export const StyleBasketList = styled.div(({ theme }) => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    [breakpoints.md]: {
        marginRight: theme.space[3],
    },
}));

export const StyleBasketSummary = styled.div(({ theme: { sizes } }) => ({
    width: '100%',
    [breakpoints.md]: {
        maxWidth: sizes.summaryBasket,
    },
}));

export const StyledCampaignText = styled.div(({ theme }) => ({
    justifyContent: 'left',
    backgroundColor: theme.colors.brandOrangeMedium,
    border: `1px solid ${theme.colors.brandOrangeMedium}`,
    borderRadius: theme.sizes.cornerRadius,
    width: '100%',
    display: 'flex',
    alignSelf: 'center',
    padding: theme.space[2],
    fontSize: theme.fontSizes['xs'],
    [breakpoints.md]: {
        justifyContent: 'center',
    },
}));
